import AgreementTabs from '@app/UiElements/Trips/AgreementTabs'

export default function install(Vue) {
  Vue.component(AgreementTabs.name, AgreementTabs)
}
